var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.5 47.5",
    className: "langIcon",
    id: "germany",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M1 24V10a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v14H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e44",
    d: "M37 14H1v10h36V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292f33",
    d: "M33 32H5a4 4 0 0 1-4-4v-4h36v4a4 4 0 0 1-4 4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.f47b6303c45f80a94273123423dd767b.svg";
export { ForwardRef as ReactComponent };